import actions from './actions'
import saga from '../../GeneralListFunctions/sagaFactory'

export default () =>
  saga(
    actions,
    (state) => `v1/auth/user/${state.user.crud.object.id}/role`,
    (state) => state.addUserRole
  )
